module.exports = __webpack_public_path__ + "img/46804D_CBE9AC_90B57C_95D38F-256px.fbabca21.png";